const mergeClasses = (...classes: (string | undefined | boolean)[]): string =>
  classes.map((c) => (typeof c === 'object' ? c : c)).join(' ');

export default mergeClasses;
